import { useEffect, useRef } from 'react'
import styles from './SpaceScene.module.css'

const SpaceScene = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    const ctx = canvas.getContext('2d')
    if (!ctx) return

    const container = containerRef.current
    if (!container) return

    const resizeCanvas = () => {
      const rect = container.getBoundingClientRect()
      canvas.width = rect.width
      canvas.height = rect.height
    }

    resizeCanvas()
    window.addEventListener('resize', resizeCanvas)

    // Particle system
    interface Particle {
      x: number
      y: number
      z: number
      size: number
      speed: number
      color: string
    }

    const particles: Particle[] = []
    const particleCount = 200

    // Create particles
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        z: Math.random() * 2000,
        size: Math.random() * 2 + 0.5,
        speed: Math.random() * 2 + 0.5,
        color: `rgba(255, 255, 255, ${Math.random() * 0.5 + 0.2})`
      })
    }

    let animationFrame: number
    let time = 0

    const animate = () => {
      if (!ctx) return

      ctx.fillStyle = 'rgba(0, 0, 0, 0.1)'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      time += 0.01

      particles.forEach((particle) => {
        // Move particles forward
        particle.z -= particle.speed

        // Reset if too close
        if (particle.z <= 0) {
          particle.z = 2000
          particle.x = Math.random() * canvas.width
          particle.y = Math.random() * canvas.height
        }

        // Calculate perspective
        const perspective = 500
        const scale = perspective / (perspective + particle.z)
        const x = (particle.x - canvas.width / 2) * scale + canvas.width / 2
        const y = (particle.y - canvas.height / 2) * scale + canvas.height / 2

        // Draw particle
        ctx.beginPath()
        ctx.arc(x, y, particle.size * scale, 0, Math.PI * 2)
        ctx.fillStyle = particle.color
        ctx.fill()
      })

      animationFrame = requestAnimationFrame(animate)
    }

    animate()

    return () => {
      window.removeEventListener('resize', resizeCanvas)
      if (animationFrame) {
        cancelAnimationFrame(animationFrame)
      }
    }
  }, [])

  return (
    <div ref={containerRef} className={styles.spaceScene}>
      <canvas ref={canvasRef} className={styles.canvas}></canvas>
    </div>
  )
}

export default SpaceScene

